import { graphql } from '@/gql';
import type { AssignPartnerToRideMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const assignPartnerToRide = async ({ requestId, partnerCode }: AssignPartnerToRideMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AssignPartnerToRide($requestId: String!, $partnerCode: String!) {
        assignPartnerToRide(requestId: $requestId, partnerCode: $partnerCode) {
          partnerId
        }
      }
    `),
    variables: {
      requestId,
      partnerCode,
    },
  });

  return !!response.data?.assignPartnerToRide;
};
